module.exports = __webpack_public_path__ + "static/media/you-voted-mobile.e8ecc47f.png";